import NoCurrentRentalModal from './NoCurrentRentalModal';

export default NoCurrentRentalModal;
